import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import {NastaveniUcetniJednotkaDataService} from "./nastaveni-ucetni-jednotky-data.service";



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {provide: NastaveniUcetniJednotkaDataService, useClass: NastaveniUcetniJednotkaDataService, multi: false}
  ]
})
export class NastaveniUcetniJednotkaDataModule { }
